export const DataListActions = {
    LIST_LOADED: "LIST_LOADED",
    LIST_PAGINATED: "LIST_PAGINATED",
    LIST_EXHAUSTED: "LIST_EXHAUSTED",
    LIST_RESET: "LIST_RESET",
    DETAIL_LOADED: "DETAIL_LOADED",
    UPDATE_COLUMN_SORT_STATE: "UPDATE_COLUMN_SORT_STATE",
    PARAMS_UPDATED: "PARAMS_UPDATED",
    PARAMS_REMOVED: "PARAMS_REMOVED",
    PARAMS_OFFSET_RESET: "PARAMS_OFFSET_RESET",
    ROW_SELECTED: "ROW_SELECTED",
};
